import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { HeadingBlock } from "containers"
import SelectSectionMapLocationContainer from "./select-section"
import SearchSectionMapLocationContainer from "./search-section"
import { withRadium } from "../../higher-order-components"

class HeaderSectionMapLocationContainer extends PureComponent {
  render() {
    return (
      <div key={"HeaderSectionMapLocationContainer"} style={styles.searchSection}>
        {this.props.heading && (
          <HeadingBlock
            value={this.props.heading}
            description={this.props.description}
            textAlign={"center"}
            tag={"h3"} />
        )}
        {this.props.searchType === "search" && (
          <SearchSectionMapLocationContainer
            searchOverride={this.props.searchOverride || this.props.searchInput.postcode}
            dealerSearchEndPoint={this.props.dealerSearchEndPoint}
            updateLocationInSearchInput={this.props.updateLocationInSearchInput}
            gtmMapping={this.props.gtmMapping}
            disableFilters={this.props.disableFilters}
            filters={this.props.filters}
            handleToggleFilter={this.props.handleToggleFilter}
            activeIndex={this.props.activeIndex}
            handleNZLocations={this.props.handleNZLocations} />
        )}
        {this.props.searchType === "select" && (
          <SelectSectionMapLocationContainer
            dropDownDisabled={this.props.dropDownDisabled}
            handleSelectDropDown={this.props.handleSelectDropDown}
            activeIndexOfStates={this.props.activeIndexOfStates}
            uniqStates={this.props.uniqStates}
            dropDownLabel={this.props.dropDownLabel} />
        )}
      </div>
    )
  }
}

HeaderSectionMapLocationContainer.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  searchType: PropTypes.string,
  dealerSearchEndPoint: PropTypes.string,
  gtmMapping: PropTypes.object,
  searchOverride: PropTypes.string,
  filters: PropTypes.array,
  searchInput: PropTypes.object,
  disableFilters: PropTypes.bool,
  activeIndex: PropTypes.number,
  dropDownDisabled: PropTypes.bool,
  handleSelectDropDown: PropTypes.func,
  updateLocationInSearchInput: PropTypes.func,
  handleToggleFilter: PropTypes.func,
  activeIndexOfStates: PropTypes.number,
  uniqStates: PropTypes.array,
  dropDownLabel: PropTypes.string
}

const styles = {
  searchSection: { padding: "2em 0", textAlign: "center" }
}

export default withRadium()(HeaderSectionMapLocationContainer)



// WEBPACK FOOTER //
// ./src/containers/map-location/header-section.jsx